import React from 'react';

export const ProgramDescriptionCard = ({ description }) => (
    <div className="card p-3 mb-3 h-100">
        <h5 className="text-strong mb-3">Program Description</h5>
        <label className="d-block text-muted">Description</label>
        <div>{description}</div>
    </div>
);
